import { Component } from "react";
import PropTypes from "prop-types";
interface IProps {
	theme: string | object;
}

class ThemeProvider extends Component<IProps> {
	static childContextTypes = {
		theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	};

	getChildContext() {
		const { theme } = this.props;

		return {
			theme,
		};
	}

	render() {
		return this.props.children;
	}
}

export default ThemeProvider;
